import React from 'react';
import PersonalImage from '../images/rokon.png';

export default function Banner() {
    return (
        <div className='md:flex justify-center items-center my-5'>
            <div className='text-white text-2xl md:text-3xl md:w-1/2 p-5 border-l-8 border-cyan-600 font-mono'>
                <div className='text-4xl text-cyan-400 font-bold'>Hi, it's Roknuzzaman!</div><br />
                I am a Web Developer. Currently practicing the MERN stack and actively looking for roles similar to Junior Front-End Developer / Junior Full Stack Developer (MERN Stack).
            </div>
            <div><img className='border-2 border-cyan-600 rounded-full shadow-lg shadow-cyan-600' src={PersonalImage} alt="" /></div>
        </div>
    )
}
